import React from 'react';
import { Box } from '@mui/material';
import HeaderSection from '../components/home/HeaderSection.tsx';
import AboutSection from '../components/home/AboutSection.tsx';
import LocationsList from '../components/dynamic/LocationsList.tsx';
import WavyDivider from '../components/common/WavyDivider.tsx';
import ServicesList from '../components/dynamic/ServicesList.tsx';
import CallToAction from '../components/home/Action.tsx';
import Testimonials from '../components/dynamic/Testimonials.tsx';
import FAQ from '../components/dynamic/faq.tsx';
import Gallary from '../components/home/Gallary.tsx';

const Home: React.FC = () => {
  
  return (
    <Box>
      <HeaderSection />
      <AboutSection />
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          backgroundColor: 'background.default',
        }}
      >
        <Box sx={{ flex: 1 }}>
          <LocationsList />
        </Box>
        <Box sx={{ flex: 2 }}>
          <Gallary />
        </Box>
      </Box>
      <WavyDivider />

      <ServicesList />
      <CallToAction />

      <WavyDivider />
      
      <Testimonials />
      <FAQ />
    </Box>
  );
};

export default Home;